import { Fragment } from "react";
import { Link, useLocation } from "react-router";
import { cn } from "../utils";
import { useBreadcrumbsStore } from "./breadcrumbs-store";
import { getBreadcrumbs } from "./get-breadcrumbs";

/**
 * The trail of the current URL above a page's content, one crumb per segment. A page names its
 * entity's segment through `useBreadcrumbTitle`, and the navigation says which static paths have a
 * page — `getBreadcrumbs` carries the rules. Only the URL's own words are capitalised: a name is
 * shown as its owner wrote it.
 */
export function ContentBoxBreadcrumbs() {
	/** Hooks */
	const { pathname } = useLocation();
	const registrations = useBreadcrumbsStore((store) => store.registrations);
	const pagePaths = useBreadcrumbsStore((store) => store.pagePaths);

	/** Computed */
	const breadcrumbs = getBreadcrumbs(pathname, registrations, pagePaths);

	/** Render */
	return (
		<div className="h-stack items-center shrink">
			{breadcrumbs.map((breadcrumb, index) => {
				const className = cn("text-sm opacity-50", !breadcrumb.isNamed && "capitalize");
				return (
					<Fragment key={breadcrumb.path}>
						{index > 0 && <p className="text-xs opacity-35">/</p>}
						{breadcrumb.isLink ? (
							<Link
								to={breadcrumb.path}
								className={cn(className, "hover:underline hover:opacity-100")}
							>
								{breadcrumb.label}
							</Link>
						) : (
							<p className={className}>{breadcrumb.label}</p>
						)}
					</Fragment>
				);
			})}
		</div>
	);
}
